<template>
	<div v-if="result && !suretyDoesNotExist">
		<!-- <loading
      :active.sync="loading"
      :is-full-page="true"
    >
    
    </loading> -->
		<!-- <pulse-loader
      :loading="loading"
      color="red"
      size="20px"
      class="text-center"
    >
    </pulse-loader> -->
		<div
		
			class="form--v10 px-3 py-4 px-md-5 py-md-6 mb-3 rounded--10 bg-color--light--1"
		>
			
			<form class="form">
				<div class="container">
					<h4 class="text-center" v-if="!uploaded && !isSurety">{{this.$t("register.uploadCustomerDocument")}}</h4>
					<h4 class="text-center" v-if="uploaded && !isSurety">{{this.$t("register.editCustomerDocument")}}</h4>
					<h4 class="text-center" v-if="uploaded && isSurety">{{this.$t("register.editSuretyDocument")}}</h4>
					<h4 class="text-center" v-if="!uploaded && isSurety">{{this.$t("register.uploadSuretyDocument")}}</h4>


					<br />
					<!-- <div class="alert alert-info" role="alert">
						سایز فایل های ارسالی نباید بیش‌تر از ۱۰۰ کیلو بایت باشد
					</div> -->
					<!-- <div class="alert alert-success" role="alert" v-show="alert_success">
						مدارک با موفقیت آپلود شد
					</div> -->
					<!-- <div class="alert alert-danger" role="alert" v-show="alert_error">
						در آپلود مدارک مشکلی پیش آمده است
					</div> -->
					<div class="large-12 medium-12 small-12 cell">
						<!-------------------------------------- test ---------------------------------------------->

						<!-------------------------------------- END TEST ------------------------------------------->
						<!--melliCardFront-->
						<div class="form-group">
							<label class="form__label font-size--15 font-w--400">{{
								$t("تصویر جلو کارت ملی*")
							}}</label>
							<div class="input-group mb-3">
								<div class="custom-file">
									<input
										id="melliCardFront"
										type="file"
										class="custom-file-input"
										@blur="$v.mellicard_front.$touch()"
										:class="{ 'is-invalid': $v.mellicard_front.$error && !ShowImageOf_mellicard_front && $v.$dirty }"
										@change="processMelliCardFront($event)"
									/>

									<label class="custom-file-label" for="melliCardFront"
										>انتخاب فایل</label
									>
								</div>
							</div>
							<div
								class="invalid-feedback"
								:class="{ 'd-block': $v.mellicard_front.$error }"
								v-if="!$v.mellicard_front.required && !ShowImageOf_mellicard_front && $v.$dirty"
							>
								ورود تصویر جلو کارت ملی لازم است
							</div>
							<div
								class="invalid-feedback"
								:class="{ 'd-block': $v.mellicard_front.$error }"
								v-if="!$v.mellicard_front.mf_size"
							>
								{{ $t("uploadDocs.sizeOver6M") }}
							</div>
							<!-- <img  :src="testImage" alt="عکس کارت ملی">-->
							
							
							<div class="file-listing">
								<div class="d-flex flex-row justify-content-between m-auto align-items-center col-8">
								<a v-if="uploaded && !mellicard_front && ShowImageOf_mellicard_front" 
								:href="ShowImageOf_mellicard_front">{{this.$t("تصویر جلو کارت ملی")}}</a>
								<img v-if="uploaded && !mellicard_front && ShowImageOf_mellicard_front"  
								:src="ShowImageOf_mellicard_front" alt="">
								</div>
								{{ mellicard_front.name }}
								<span
									class="remove-file"
									v-show="mellicard_front"
									v-on:click="removeMelliCardFront()"
									>حذف</span
								>
							</div>
						</div>
						<!--CreditRate-->

						<div class="form-group">
							<label class="form__label font-size--15 font-w--400"
								>{{ $t("مدرک اعتبار سنجی*") }}
							</label>
							<button v-popover:foo.top @click.prevent="" class="popover_btn">
								راهنما
							</button>

							<Popover name="foo" :pointer="false" transition="'fade-in'">
								برای دریافت رتبه اعتبار سنجی خود به سامانه
								<span
									><a
										href="https://www.icescoring.com/"
										target="_blank"
										rel="noopener noreferrer"
										>آیس</a
									></span
								>
								مراجعه کنید و فایل دریافتی را اینجا بارگزاری نمایید.
							</Popover>

							<div class="input-group mb-3">
								<div class="custom-file">
									<input
										id="CreditRate"
										type="file"
										class="custom-file-input"
										@blur="$v.credit_rate.$touch()"
										:class="{ 'is-invalid': $v.credit_rate.$error && !ShowImageOf_credit_rate && $v.$dirty }"
										@change="processCreditRate($event)"
									/>
									<label class="custom-file-label" for="CreditRate"
										>انتخاب فایل</label
									>
								</div>
							</div>
							<div
								class="invalid-feedback"
								:class="{ 'd-block': $v.credit_rate.$error }"
								v-if="!$v.credit_rate.required && !ShowImageOf_credit_rate && $v.$dirty"
							>
								ورود فایل مدرک اعتبار سنجی لازم است
							</div>
							<div
								class="invalid-feedback"
								:class="{ 'd-block': $v.credit_rate.$error }"
								v-if="!$v.credit_rate.cr_size"
							>
								{{ $t("uploadDocs.sizeOver1_5M") }}
							</div>
							<div class="file-listing">
								<div class="d-flex flex-row justify-content-between m-auto align-items-center col-8">
								<a v-if="uploaded && !credit_rate && ShowImageOf_credit_rate" 
								:href="ShowImageOf_credit_rate">{{this.$t("مدرک اعتبار سنجی")}}</a>
								<img v-if="uploaded && !credit_rate && ShowImageOf_credit_rate"  
								:src="ShowImageOf_credit_rate" alt="">
								</div>
								{{ credit_rate.name }}
								<span
									class="remove-file"
									v-show="credit_rate"
									v-on:click="removeCreditRate()"
									>حذف</span
								>
							</div>
						</div>

						<!--melliCardbehind-->
						<div class="form-group">
							<label class="form__label font-size--15 font-w--400">{{
								$t("تصویر پشت کارت ملی")
							}}</label>
							<div class="input-group mb-3">
								<div class="custom-file">
									<input
										id="melliCardbehind"
										type="file"
										class="custom-file-input"
										@blur="$v.mellicard_behind.$touch()"
										:class="{ 'is-invalid': $v.mellicard_behind.$error }"
										@change="processMelliCardBehind($event)"
									/>
									<label class="custom-file-label" for="melliCardbehind"
										>انتخاب فایل</label
									>
								</div>
							</div>
							<div
								class="invalid-feedback"
								:class="{ 'd-block': $v.mellicard_behind.$error }"
								v-if="!$v.mellicard_behind.required"
							>
								ورود تصویر پشت کارت ملی لازم است
							</div>
							<div
								class="invalid-feedback"
								:class="{ 'd-block': $v.mellicard_behind.$error }"
								v-if="!$v.mellicard_behind.mb_size"
							>
								{{ $t("uploadDocs.sizeOver100") }}
							</div>
							<div class="file-listing">
								<div class="d-flex flex-row justify-content-between m-auto align-items-center col-8">
								<a v-if="uploaded && !mellicard_behind && ShowImageOf_mellicard_behind" 
								:href="ShowImageOf_mellicard_behind">{{this.$t("تصویر پشت کارت ملی")}}</a>
								<img v-if="uploaded && !mellicard_behind && ShowImageOf_mellicard_behind " 
								 :src="ShowImageOf_mellicard_behind" alt="">
								</div>
								{{ mellicard_behind.name }}
								<span
									class="remove-file"
									v-show="mellicard_behind"
									v-on:click="removeMelliCardBehind($event)"
									>حذف</span
								>
							</div>
						</div>
						<!--IdentityFirstpage-->
						<div class="form-group">
							<label class="form__label font-size--15 font-w--400">{{
								$t("صفحه اول شناسنامه")
							}}</label>
							<div class="input-group mb-3">
								<div class="custom-file">
									<input
										id="IdentityFirstpage"
										type="file"
										class="custom-file-input"
										@blur="$v.identity_firstpage.$touch()"
										:class="{ 'is-invalid': $v.identity_firstpage.$error }"
										@change="processIdentityFirstpage($event)"
									/>
									<label class="custom-file-label" for="IdentityFirstpage"
										>انتخاب فایل</label
									>
								</div>
							</div>
							<div
								class="invalid-feedback"
								:class="{ 'd-block': $v.identity_firstpage.$error }"
								v-if="!$v.identity_firstpage.required"
							>
								ورود تصویر صفحه اول شناسنامه لازم است
							</div>
							<div
								class="invalid-feedback"
								:class="{ 'd-block': $v.identity_firstpage.$error }"
								v-if="!$v.identity_firstpage.if_size"
							>
								{{ $t("uploadDocs.sizeOver100") }}
							</div>
							<div class="file-listing">
								<div class="d-flex flex-row justify-content-between m-auto align-items-center col-8">
								<a v-if="uploaded && !identity_firstpage && ShowImageOf_identity_firstpage" 
								:href="ShowImageOf_identity_firstpage">{{this.$t("تصویر صفحه اول شناسنامه")}}</a>
								<img v-if="uploaded && !identity_firstpage && ShowImageOf_identity_firstpage " 
								 :src="ShowImageOf_identity_firstpage" alt="">
								</div>
								{{ identity_firstpage.name }}
								<span
									class="remove-file"
									v-show="identity_firstpage"
									v-on:click="removeIdentityFirstpage()"
									>حذف</span
								>
							</div>
						</div>
						<!--identityDescription-->
						<div class="form-group">
							<label class="form__label font-size--15 font-w--400">{{
								$t("صفحه توضیحات شناسنامه")
							}}</label>
							<div class="input-group mb-3">
								<div class="custom-file">
									<input
										id="identityDescription"
										type="file"
										class="custom-file-input"
										@blur="$v.identity_description.$touch()"
										:class="{ 'is-invalid': $v.identity_description.$error }"
										@change="processIdentityDescription($event)"
									/>
									<label class="custom-file-label" for="identityDescription"
										>انتخاب فایل</label
									>
								</div>
							</div>

							<div
								class="invalid-feedback"
								:class="{ 'd-block': $v.identity_description.$error }"
								v-if="!$v.identity_description.id_size"
							>
								{{ $t("uploadDocs.sizeOver100") }}
							</div>
							<div class="file-listing">
								<div class="d-flex flex-row justify-content-between m-auto align-items-center col-8">
								<a v-if="uploaded && !identity_description && ShowImageOf_identity_description" 
								:href="ShowImageOf_identity_description">{{this.$t("تصویر صفحه توضیحات شناسنامه")}}</a>
								<img v-if="uploaded && !identity_description && ShowImageOf_identity_description " 
								 :src="ShowImageOf_identity_description" alt="">
								</div>
								{{ identity_description.name }}
								<span
									class="remove-file"
									v-show="identity_description"
									v-on:click="removeIdentityDescription()"
									>حذف</span
								>
							</div>
						</div>

						<!--HousEvidence-->
						<div class="form-group">
							<label class="form__label font-size--15 font-w--400">{{
								$t("مدرک سکونت")
							}}</label>
							<div class="input-group mb-3">
								<div class="custom-file">
									<input
										id="HouseEvidence"
										type="file"
										class="custom-file-input"
										@blur="$v.house_evidence.$touch()"
										:class="{ 'is-invalid': $v.house_evidence.$error }"
										@change="processHouseEvidence($event)"
									/>
									<label class="custom-file-label" for="HouseEvidence"
										>انتخاب فایل</label
									>
								</div>
							</div>
							<div
								class="invalid-feedback"
								:class="{ 'd-block': $v.house_evidence.$error }"
								v-if="!$v.house_evidence.required"
							>
								ورود این فیلد لازم است
							</div>
							<div
								class="invalid-feedback"
								:class="{ 'd-block': $v.house_evidence.$error }"
								v-if="!$v.house_evidence.size"
							>
								{{ $t("uploadDocs.sizeOver100") }}
							</div>
							<div class="file-listing">
								<div class="d-flex flex-row justify-content-between m-auto align-items-center col-8">
								<a v-if="uploaded && !house_evidence && ShowImageOf_house_evidence" 
								:href="ShowImageOf_house_evidence">{{this.$t("تصویرمدرک سکونت")}}</a>
								<img v-if="uploaded && !house_evidence && ShowImageOf_house_evidence " 
								 :src="ShowImageOf_house_evidence" alt="">
								</div>
								{{ house_evidence.name }}
								<span
									class="remove-file"
									v-show="house_evidence"
									v-on:click="removeHouseEvidence()"
									>حذف</span
								>
							</div>
						</div>
						<!--CaccountTurnover-->
						<div class="form-group">
							<label class="form__label font-size--15 font-w--400">{{
								$t(" گردش حساب جاری")
							}}</label>
							<div class="input-group mb-3">
								<div class="custom-file">
									<input
										id="CaccountTurnover"
										type="file"
										class="custom-file-input"
										@blur="$v.caccount_turnover.$touch()"
										:class="{ 'is-invalid': $v.caccount_turnover.$error }"
										@change="processCaccountTurnover($event)"
									/>
									<label class="custom-file-label" for="CaccountTurnover"
										>انتخاب فایل</label
									>
								</div>
							</div>
							<div
								class="invalid-feedback"
								:class="{ 'd-block': $v.caccount_turnover.$error }"
								v-if="!$v.caccount_turnover.required"
							>
								ورود این فیلد لازم است
							</div>
							<div
								class="invalid-feedback"
								:class="{ 'd-block': $v.caccount_turnover.$error }"
								v-if="!$v.caccount_turnover.ct_size"
							>
								{{ $t("uploadDocs.sizeOver250") }}
							</div>
							<div class="file-listing">
								<div class="d-flex flex-row justify-content-between m-auto align-items-center col-8">
								<a v-if="uploaded && !caccount_turnover && ShowImageOf_caccount_turnover" 
								:href="ShowImageOf_caccount_turnover">{{this.$t("کردش حساب جاری")}}</a>
								<img v-if="uploaded && !caccount_turnover && ShowImageOf_caccount_turnover " 
								 :src="ShowImageOf_caccount_turnover" alt="">
								</div>
								{{ caccount_turnover.name }}
								<span
									class="remove-file"
									v-show="caccount_turnover"
									v-on:click="removeCaccountTurnover()"
									>حذف</span
								>
							</div>
						</div>

						<!--oaccount_turnover-->
						<div class="form-group">
							<label class="form__label font-size--15 font-w--400"
								>گردش حساب اصلی یا فیش حقوقی مهردار</label
							>
							<div class="input-group mb-3">
								<div class="custom-file">
									<input
										id="oaccount_turnover"
										type="file"
										class="custom-file-input"
										@blur="$v.oaccount_turnover.$touch()"
										:class="{ 'is-invalid': $v.oaccount_turnover.$error }"
										@change="processOaccountTurnover($event)"
									/>
									<label class="custom-file-label" for="oaccount_turnover"
										>انتخاب فایل</label
									>
								</div>
							</div>
							<div
								class="invalid-feedback"
								:class="{ 'd-block': $v.oaccount_turnover.$error }"
								v-if="!$v.oaccount_turnover.required"
							>
								ورود این فیلد لازم است
							</div>
							<div
								class="invalid-feedback"
								:class="{ 'd-block': $v.oaccount_turnover.$error }"
								v-if="!$v.oaccount_turnover.size"
							>
								{{ $t("uploadDocs.sizeOver250") }}
							</div>
							<div class="file-listing">
								<div class="d-flex flex-row justify-content-between m-auto align-items-center col-8">
								<a v-if="uploaded && !oaccount_turnover && ShowImageOf_oaccount_turnover" 
								:href="ShowImageOf_oaccount_turnover">{{this.$t("گردش حساب اصلی یا فیش حقوقی مهر داد")}}</a>
								<img v-if="uploaded && !oaccount_turnover && ShowImageOf_oaccount_turnover " 
								 :src="ShowImageOf_oaccount_turnover" alt="">
								</div>
								{{ oaccount_turnover.name }}
								<span
									class="remove-file"
									v-show="oaccount_turnover"
									v-on:click="removeOaccounTurnover()"
									>حذف</span
								>
							</div>
						</div>

						<!--marketing_license-->
						<!-- <div class="form-group">
              <label class="form__label font-size--15 font-w--400"
                >جواز کسب</label
              >
              <div class="input-group mb-3">
                <div class="custom-file">
                  <input
                    id="marketing_license"
                    type="file"
                    class="custom-file-input"
                    @blur="$v.marketing_license.$touch()"
                    :class="{ 'is-invalid': $v.marketing_license.$error }"
                    @change="processMarketingLicense($event)"
                  />
                  <label class="custom-file-label" for="marketing_license"
                    >انتخاب فایل</label
                  >
                </div>
              </div>
              <div
                class="invalid-feedback"
                :class="{ 'd-block': $v.marketing_license.$error }"
                v-if="!$v.marketing_license.required"
              >
                ورود این فیلد لازم است
              </div>
              <div
                class="invalid-feedback"
                :class="{ 'd-block': $v.marketing_license.$error }"
                v-if="!$v.marketing_license.size"
              >
                سایز فایل باید کمتر از ۱۰۰ کیلوبایت باشد
              </div>
              <div class="file-listing">
                {{ marketing_license.name }}
                <span
                  class="remove-file"
                  v-show="marketing_license"
                  v-on:click="removeMarketingLicense()"
                  >حذف</span
                >
              </div>
            </div> -->

						<!-- postalcode_evidence -->
						<div class="form-group">
							<label class="form__label font-size--15 font-w--400"
								>گواهی کد پستی</label
							>
							<!-- <button v-popover:foo.top @click.prevent="" class="popover_btn">
								راهنما
							</button>

							<Popover name="foo" :pointer="false" transition="'fade-in'">
								برای دریافت گواهی کد پستی به
								<span
									><a
										href="https://epostcode.post.ir/"
										target="_blank"
										rel="noopener noreferrer"
										>اینجا</a
									></span
								>
								مراجعه کنید و فایل دریافتی را بارگزاری نمایید.
							</Popover> -->
							<div class="input-group mb-3">
								<div class="custom-file">
									<input
										id="postalcode_evidence"
										type="file"
										class="custom-file-input"
										@blur="$v.postalcode_evidence.$touch()"
										:class="{ 'is-invalid': $v.postalcode_evidence.$error }"
										@change="processPostalcodeEvidence($event)"
									/>
									<label class="custom-file-label" for="postalcode_evidence"
										>انتخاب فایل</label
									>
								</div>
							</div>
							<div
								class="invalid-feedback"
								:class="{ 'd-block': $v.postalcode_evidence.$error }"
								v-if="!$v.postalcode_evidence.required"
							>
								ورود این فیلد لازم است
							</div>
							<div
								class="invalid-feedback"
								:class="{ 'd-block': $v.postalcode_evidence.$error }"
								v-if="!$v.postalcode_evidence.size"
							>
								{{ $t("uploadDocs.sizeOver100") }}
							</div>
							<div class="file-listing">
								<div class="d-flex flex-row justify-content-between m-auto align-items-center col-8">
								<a v-if="uploaded && !postalcode_evidence && ShowImageOf_postalcode_evidence" 
								:href="ShowImageOf_postalcode_evidence">{{this.$t("گواهی کد پستی ")}}</a>
								<img v-if="uploaded && !postalcode_evidence && ShowImageOf_postalcode_evidence " 
								 :src="ShowImageOf_postalcode_evidence" alt="">
								</div>
								{{ postalcode_evidence.name }}
								<span
									class="remove-file"
									v-show="postalcode_evidence"
									v-on:click="removePostalcodeEvidence()"
									>حذف</span
								>
							</div>
						</div>

						<!-- receipt_of_deposit -->
						<!-- <div class="form-group">
              <label class="form__label font-size--15 font-w--400"
                >رسید هزینه ی اعتبارسنجی</label
              >
              <div class="input-group mb-3">
                <div class="custom-file">
                  <input
                    id="receipt_of_deposit"
                    type="file"
                    class="custom-file-input"
                    @blur="$v.receipt_of_deposit.$touch()"
                    :class="{ 'is-invalid': $v.receipt_of_deposit.$error }"
                    @change="processReceiptOfDeposit($event)"
                  />
                  <label class="custom-file-label" for="receipt_of_deposit"
                    >انتخاب فایل</label
                  >
                </div>
              </div>
              <div
                class="invalid-feedback"
                :class="{ 'd-block': $v.receipt_of_deposit.$error }"
                v-if="!$v.receipt_of_deposit.required"
              >
                ورود این فیلد لازم است
              </div>
              <div
                class="invalid-feedback"
                :class="{ 'd-block': $v.receipt_of_deposit.$error }"
                v-if="!$v.receipt_of_deposit.size"
              >
                سایز فایل باید کمتر از ۱۰۰ کیلوبایت باشد
              </div>
              <div class="file-listing">
                {{ receipt_of_deposit.name }}
                <span
                  class="remove-file"
                  v-show="receipt_of_deposit"
                  v-on:click="removeReceiptOfDeposit()"
                  >حذف</span
                >
              </div>
            </div> -->

						<!-- employment_certification -->
						<div class="form-group">
							<label class="form__label font-size--15 font-w--400"
								>{{ $t("uploadDocs.employment_certificate") }}</label
							>
							<div class="input-group mb-3">
								<div class="custom-file">
									<input
										id="employment_certification"
										type="file"
										class="custom-file-input"
										@blur="$v.employment_certification.$touch()"
										:class="{
											'is-invalid': $v.employment_certification.$error,
										}"
										@change="processEmploymentCertification($event)"
									/>
									<label
										class="custom-file-label"
										for="employment_certification"
										>انتخاب فایل</label
									>
								</div>
							</div>
							<div
								class="invalid-feedback"
								:class="{ 'd-block': $v.employment_certification.$error }"
								v-if="!$v.employment_certification.required"
							>
								ورود این فیلد لازم است
							</div>
							<div
								class="invalid-feedback"
								:class="{ 'd-block': $v.employment_certification.$error }"
								v-if="!$v.employment_certification.size"
							>
								{{ $t("uploadDocs.sizeOver100") }}
							</div>
							<div class="file-listing">
								<div class="d-flex flex-row justify-content-between m-auto align-items-center col-8">
								<a v-if="uploaded && !employment_certification && ShowImageOf_employment_certification" 
								:href="ShowImageOf_employment_certification">{{ $t("uploadDocs.employment_certificate") }}</a>
								<img v-if="uploaded && !employment_certification && ShowImageOf_employment_certification " 
								 :src="ShowImageOf_employment_certification" alt="">
								</div>
								{{ employment_certification.name }}
								<span
									class="remove-file"
									v-show="employment_certification"
									v-on:click="removeEmploymentCertification()"
									>حذف</span
								>
							</div>
						</div>

						<!-- complemental -->
						<div class="form-group">
							<label class="form__label font-size--15 font-w--400"
								>مدارک تکمیلی</label
							>
							<div class="input-group mb-3">
								<div class="custom-file">
									<input
										id="complemental"
										type="file"
										class="custom-file-input"
										@blur="$v.complemental.$touch()"
										:class="{ 'is-invalid': $v.complemental.$error }"
										@change="processComplemental($event)"
									/>
									<label class="custom-file-label" for="complemental"
										>انتخاب فایل</label
									>
								</div>
							</div>

							<div
								class="invalid-feedback"
								:class="{ 'd-block': $v.complemental.$error }"
								v-if="!$v.complemental.size"
							>
								{{ $t("uploadDocs.sizeOver150") }}
							</div>
							<div class="file-listing">
								<div class="d-flex flex-row justify-content-between m-auto align-items-center col-8">
								<a v-if="uploaded && !complemental && ShowImageOf_complemental" 
								:href="ShowImageOf_complemental">{{ $t("مدارک تکمیلی") }}</a>
								<img v-if="uploaded && !complemental && ShowImageOf_complemental " 
								 :src="ShowImageOf_complemental" alt="">
								</div>
								{{ complemental.name }}
								<span
									class="remove-file"
									v-show="complemental"
									v-on:click="removeComplemental()"
									>حذف</span
								>
							</div>
						</div>

						<!-- remmendation -->
						<div class="form-group">
							<label class="form__label font-size--15 font-w--400"
								>معرفی نامه سازمان</label
							>
							<div class="input-group mb-3">
								<div class="custom-file">
									<input
										id="recommendation"
										type="file"
										class="custom-file-input"
										@blur="$v.recommendation.$touch()"
										:class="{ 'is-invalid': $v.recommendation.$error }"
										@change="processRecommendation($event)"
									/>
									<label class="custom-file-label" for="recommendation"
										>انتخاب فایل</label
									>
								</div>
							</div>

							<div
								class="invalid-feedback"
								:class="{ 'd-block': $v.recommendation.$error }"
								v-if="!$v.recommendation.size"
							>
								{{ $t("uploadDocs.sizeOver100") }}
							</div>
							<div class="file-listing">
								<div class="d-flex flex-row justify-content-between m-auto align-items-center col-8">
								<a v-if="uploaded && !recommendation && ShowImageOf_recommendation" 
								:href="ShowImageOf_recommendation">{{ $t("معرفی نامه سازمان ") }}</a>
								<img v-if="uploaded && !recommendation && ShowImageOf_recommendation " 
								 :src="ShowImageOf_recommendation" alt="">
								</div>
								{{ recommendation.name }}
								<span
									class="remove-file"
									v-show="recommendation"
									v-on:click="removeRecommendation()"
									>حذف</span
								>
							</div>
						</div>
					</div>

					<br />
					<div
						class="d-flex justify-content-between align-items-center flex-column"
					>
						<button
							class="btn btn-bg--primary btn-size--md btn-hover--3d"
							type="submit"
							@click.prevent="submitFiles"
						>
							<span class="btn__text">آپلود مدارک</span>
						</button>
					</div>
				</div>
			</form>
		</div>
	</div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
// import PulseLoader from "vue-spinner/src/PulseLoader.vue";
// import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
// import "vue-loading-overlay/dist/vue-loading.css";
// import { popover } from "vue-strap";
export default {
	data() {
		return {
			
			
			suretyDoesNotExist:false,
			routeName:null,
			isSurety:false,
			isFirstSurety:false,
			suretyID:"",
			result:false,
			mellicard_front: "",
			mellicard_behind: "",
			credit_rate: "",
			identity_firstpage: "",
			identity_description: "",
			house_evidence: "", //اجاره نامه یا سند مالکیت
			caccount_turnover: "", //گردش جاری

			oaccount_turnover: "", //گردش حساب اصلی یا فیش حقوقی مهردار
			// marketing_license: "", //جواز کسب
			postalcode_evidence: "", //گواهی کد پستی
			// receipt_of_deposit: "", //  رسید هزینه ی اعتبارسنجی
			employment_certification: "", //جواز کسب - گواهی اشتغال
			complemental: "", // معرفی نامه سازمان
			recommendation: "", //رضایت نامه اعتبار سنجی
			ShowImageOf_mellicard_front: "",
			ShowImageOf_mellicard_behind: "",
			ShowImageOf_credit_rate: "",
			ShowImageOf_identity_firstpage: "",
			ShowImageOf_identity_description: "",
			ShowImageOf_house_evidence: "", //اجاره نامه یا سند مالکیت
			ShowImageOf_caccount_turnover: "", //گردش جاری

			ShowImageOf_oaccount_turnover: "", //گردش حساب اصلی یا فیش حقوقی مهردار
			
			ShowImageOf_postalcode_evidence: "", //گواهی کد پستی
			
			ShowImageOf_employment_certification: "", //جواز کسب - گواهی اشتغال
			ShowImageOf_complemental: "", // معرفی نامه سازمان
			ShowImageOf_recommendation: "", //رضایت نامه اعتبار سنجی

			alert_success: false,
			alert_error: false,

			uploaded: false,
			loading: true,
			// color:"red",
			// size: "20px" ,

			files: [],
			options: [],
			submitStatus: "",

			size20: 20480,
			size50: 51200,
			size100: 102400,
			size150: 153600,
			size200: 204800,
			size250: 256000,
			size500: 512000,
			size5M: 5242880,
			size6M: 6291456,
			size1_5M: 1572864,
		};
	},
	mounted() {
		
		this.checkRouteName()
		
		
		
	},
	watch:
	{
		'$route.name':
		{
			handler:function ()
			{
				this.checkRouteName()
			}
		}
	},
	methods: {
		
		checkRouteName()
		{
			this.setDataNull()
			this.result = false
			this.suretyDoesNotExist = false
			
			
			this.routeName = this.$route.name
			
		if(this.routeName=="upload-first-surty-docs")
		{
			this.isSurety=true
			this.isFirstSurety=true
		}
		else if(this.routeName=="upload-second-surty-docs")
		{
			this.isSurety=true
			this.isFirstSurety=false
		}
		else
		{
			this.isSurety = false
			
			this.isFirstSurety = false
		}
		
		
		this.getDocs();
		
		
		},
		setDataNull()
		{
			// this.suretyDoesNotExist=false
			// this.routeName=null
			// this.isSurety=false
			// this.isFirstSurety=false
			this.suretyID=""
			this.result=false
			this.mellicard_front= ""
			this.mellicard_behind= ""
			this.credit_rate= ""
			this.identity_firstpage= ""
			this.identity_description= ""
			this.house_evidence= "" 
			this.caccount_turnover= "" 
			this.oaccount_turnover= ""
			this.postalcode_evidence= ""
			
			this.employment_certification= "" 
			this.complemental= "" 
			this.recommendation= "" 
			this.alert_success= false
			this.alert_error= false
			this.uploaded= false
			this.loading= true
			

			this.files= []
			this.options= []
			this.submitStatus= ""
		},
		setDocs(res)
		{
			let path="http://www.faramiran.com/"
			if(res.mellicard_front)
			{
				this.ShowImageOf_mellicard_front = path+ res.mellicard_front
			}
			else
			{
				this.ShowImageOf_mellicard_front = ""
			}
			if(res.mellicard_behind)
			{
				this.ShowImageOf_mellicard_behind = path+ res.mellicard_behind
			}
			else
			{
				this.ShowImageOf_mellicard_behind = ""
			}
			if(res.credit_rate)
			{
				this.ShowImageOf_credit_rate = path+ res.credit_rate
			}
			else
			{
				this.ShowImageOf_credit_rate = ""
			}
			if(res.identity_firstpage)
			{
				this.ShowImageOf_identity_firstpage = path+ res.identity_firstpage
			}
			else
			{
				this.ShowImageOf_identity_firstpage=""
			}
			if(res.identity_description)
			{
				this.ShowImageOf_identity_description = path+ res.identity_description
			}
			else
			{
				this.ShowImageOf_identity_description = ""
			}
			if(res.house_evidence)
			{
				this.ShowImageOf_house_evidence = path+ res.house_evidence
			}
			else
			{
				this.ShowImageOf_house_evidence = ""
			}
			if(res.caccount_turnover)
			{
				this.ShowImageOf_caccount_turnover = path+ res.caccount_turnover
			}
			else
			{
				this.ShowImageOf_caccount_turnover
			}
			if(res.oaccount_turnover)
			{
				this.ShowImageOf_oaccount_turnover = path+ res.oaccount_turnover
			}
			else
			{
				this.ShowImageOf_oaccount_turnover = ""
			}
			if(res.postalcode_evidence)
			{
				this.ShowImageOf_postalcode_evidence = path+ res.postalcode_evidence
			}
			else
			{
				this.ShowImageOf_postalcode_evidence
			}
			if(res.employment_certification)
			{
				this.ShowImageOf_employment_certification = path+ res.employment_certification
			}
			else
			{
				this.ShowImageOf_employment_certification = ""
			}
		
			if(res.complemental)
			{
				this.ShowImageOf_complemental = path+ res.complemental
			}
			else
			{
				this.ShowImageOf_complemental = ""
			}
			if(res.recommendation)
			{
				this.ShowImageOf_recommendation = path+ res.recommendation
			}
			else
			{
				this.ShowImageOf_recommendation = ""
			}
			
			
		},
		getDocs() {
			let load = this.$loading.show();
			
				this.$store
				.dispatch("getUserDocs",{isSurety:this.isSurety ,isFirstSurety:this.isFirstSurety})
				.then((resp) => {
					console.log(resp);
					this.setDocs(resp.body)
					this.setDataNull()
					//this.mellicard_front = path+ resp.body.mellicard_front
					this.uploaded = true;
					
					//console.log(this.mellicard_front)
					this.result = true
					if(this.isSurety)
					{
						this.suretyID = resp.body.customer
					}
					load.hide()
				})
				.catch((err) => {
					if(this.isSurety && err.status==404)
					{
						this.setDocs({})
						this.setDataNull()
						if(err.body.customer)
						{
							this.suretyID = err.body.customer
						}
						else
						{
							this.$noty.error(this.$t("alert.suretyDoesNotExist"))
							this.suretyDoesNotExist = true
							if(this.isSurety)
							{
								if(this.isFirstSurety)
								{
								this.$router.push({name:"firstSuretyIdentityInfo"})
								}
								else
								{
									this.$router.push({name:"secondSuretyIdentityInfo"})
								}
							}
							

							
						}
						
						
					}
					else if (err.status==404)
					{
						this.setDocs({})
						this.setDataNull()
					}
					
					console.log(err);
					this.uploaded = false;
					this.result=true
					load.hide()
				});
		
			
		},
		processMelliCardFront(event) {
			this.mellicard_front = event.target.files[0];
		},
		processMelliCardBehind(event) {
			this.mellicard_behind = event.target.files[0];
		},
		processIdentityFirstpage(event) {
			this.identity_firstpage = event.target.files[0];
		},
		processIdentityDescription(event) {
			this.identity_description = event.target.files[0];
		},
		processHouseEvidence(event) {
			this.house_evidence = event.target.files[0];
		},
		processCaccountTurnover(event) {
			this.caccount_turnover = event.target.files[0];
		},
		// processMarketingLicense(event) {
		//   this.marketing_license = event.target.files[0];
		// },
		processCreditRate(event) {
			this.credit_rate = event.target.files[0];
		},
		processOaccountTurnover(event) {
			this.oaccount_turnover = event.target.files[0];
		},
		processPostalcodeEvidence(event) {
			this.postalcode_evidence = event.target.files[0];
		},
		// processReceiptOfDeposit(event) {
		//   this.receipt_of_deposit = event.target.files[0];
		// },
		processEmploymentCertification(event) {
			this.employment_certification = event.target.files[0];
		},
		processComplemental(event) {
			this.complemental = event.target.files[0];
		},
		processRecommendation(event) {
			this.recommendation = event.target.files[0];
		},

		// ==================   remove methodes  ==============================

		removeMelliCardFront() {
			this.mellicard_front = "";
		},
		removeMelliCardBehind() {
			this.mellicard_behind = "";
			// event.target.files[0].remove();
		},
		removeIdentityFirstpage() {
			this.identity_firstpage = "";
		},
		removeIdentityDescription() {
			this.identity_description = "";
		},
		removeHouseEvidence() {
			this.house_evidence = "";
		},
		removeCaccountTurnover() {
			this.caccount_turnover = "";
		},
		// removeMarketingLicense() {
		//   this.marketing_license = "";
		// },
		removeCreditRate() {
			this.credit_rate = "";
		},
		removeOaccounTurnover() {
			this.oaccount_turnover = "";
		},
		removePostalcodeEvidence() {
			this.postalcode_evidence = "";
		},
		// removeReceiptOfDeposit() {
		//   this.receipt_of_deposit = "";
		// },
		removeEmploymentCertification() {
			this.employment_certification = "";
		},
		removeComplemental() {
			this.complemental = "";
		},
		removeRecommendation() {
			this.recommendation = "";
		},

		submitFiles() {
			let data = new FormData();
			if (this.mellicard_front) {
				data.append("mellicard_front", this.mellicard_front);
			}
			if (this.mellicard_behind) {
				data.append("mellicard_behind", this.mellicard_behind);
			}
			if (this.credit_rate) {
				data.append("credit_rate", this.credit_rate);
			}
			if (this.identity_firstpage) {
				data.append("identity_firstpage", this.identity_firstpage);
			}
			if (this.identity_description) {
				data.append("identity_description", this.identity_description);
			}
			if (this.house_evidence) {
				data.append("house_evidence", this.house_evidence);
			}
			if (this.caccount_turnover) {
				data.append("caccount_turnover", this.caccount_turnover);
			}
			// if (this.marketing_license) {
			//   data.append("marketing_license", this.marketing_license);
			// }
			if (this.oaccount_turnover) {
				data.append("oaccount_turnover", this.oaccount_turnover);
			}
			if (this.postalcode_evidence) {
				data.append("postalcode_evidence", this.postalcode_evidence);
			}
			// if (this.receipt_of_deposit) {
			//   data.append("receipt_of_deposit", this.receipt_of_deposit);
			// }
			if (this.employment_certification) {
				data.append("employment_certification", this.employment_certification);
			}
			if (this.complemental) {
				data.append("complemental", this.complemental);
			}
			if (this.recommendation) {
				data.append("recommendation", this.recommendation);
			}
			if(this.isSurety)
			{
				data.append("suretyID",this.suretyID)
			}
			// if (this.recommendation) {
			//   data.append("recommendation", this.recommendation);
			// }

			if (!this.uploaded) {
				this.$v.$touch();
				if (this.$v.$invalid) {
					// this.submitStatus = "ERROR";
					this.$noty.error("ایرادات مشخص شده را رفع نمایید");
				} else {
					let load = this.$loading.show();
					
					this.$store
						.dispatch("createUserDocs", {data:data,isSurety:this.isSurety})
						.then((resp) => {
							console.log(resp);
							this.$noty.success(this.$t("alert.successUploaded"))
							
							//this.$router.push("/customer/success-customer-doc");
							this.alert_success = true;
							this.getDocs()
							load.hide();
						})
						.catch((error) => {
							console.log(error);
							this.alert_error = true;
							// this.loading=false
							load.hide();
							this.$noty.error("در آپلود مدارک مشکلی به وجود آمده است");
						});
				}
			} else {
				this.$v.$touch();
				let load = this.$loading.show();
				this.$store
					.dispatch("updateUserDocs", {data:data,isSurety:this.isSurety})
					.then((resp) => {
						console.log(resp);
						this.$noty.success(this.$t("alert.successUploaded"))
						//this.$router.push("/customer/success-customer-doc");
						this.getDocs()
						//this.checkRouteName()
						this.alert_success = true;
						load.hide();
					})
					.catch((error) => {
						console.log(error);
						this.alert_error = true;
						// this.loading=false
						load.hide();
						this.$noty.error("در آپلود مدارک مشکلی به وجود آمده است");
					});
			}
		},
	},
	validations: {
		mellicard_front: {
			required,
			mf_size(value) {
				if (!value) {
					return true;
				}
				let file = value;
				return file.size < this.size5M;
			},
		},
		mellicard_behind: {
			mb_size(value) {
				if (!value) {
					return true;
				}
				let file = value;
				return file.size < this.size5M;
			},
		},
		credit_rate: {
			required,
			cr_size(value) {
				if (!value) {
					return true;
				}
				let file = value;
				return file.size < this.size5M;
			},
		},
		identity_firstpage: {
			if_size(value) {
				if (!value) {
					return true;
				}
				let file = value;
				return file.size < this.size5M;
			},
		},
		identity_description: {
			id_size(value) {
				if (!value) {
					return true;
				}
				let file = value;
				return file.size < this.size5M;
			},
		},
		house_evidence: {
			size(value) {
				if (!value) {
					return true;
				}
				let file = value;
				return file.size < this.size5M;
			},
		}, //اجاره نامه یا سند مالکیت
		caccount_turnover: {
			ct_size(value) {
				if (!value) {
					return true;
				}
				let file = value;
				return file.size < this.size5M;
			},
		}, //گردش مالی
		// marketing_license: {
		//   required,
		//   size(value) {
		//     if (!value) {
		//       return true;
		//     }
		//     let file = value;
		//     return file.size < 100000;
		//   },
		// },
		oaccount_turnover: {
			size(value) {
				if (!value) {
					return true;
				}
				let file = value;
				return file.size < this.size5M;
			},
		}, //گردش حساب اصلی یا فیش حقوقی مهردار

		postalcode_evidence: {
			size(value) {
				if (!value) {
					return true;
				}
				let file = value;
				return file.size < this.size5M;
			},
		}, //گواهی کد پستی
		// receipt_of_deposit: {
		//   required,
		//   size(value) {
		//     if (!value) {
		//       return true;
		//     }
		//     let file = value;
		//     return file.size < 100000;
		//   },
		// }, //  رسید هزینه ی اعتبارسنجی
		employment_certification: {
			size(value) {
				if (!value) {
					return true;
				}
				let file = value;
				return file.size < this.size5M;
			},
		}, //جواز کسب - گواهی اشتغال
		complemental: {
			size(value) {
				if (!value) {
					return true;
				}
				let file = value;
				return file.size < this.size5M;
			},
		}, // معرفی نامه سازمان
		recommendation: {
			size(value) {
				if (!value) {
					return true;
				}
				let file = value;
				return file.size < this.size5M;
			},
		}, //رضایت نامه اعتبار سنجی
	},

	components: {
		// popover,
		// PulseLoader,
		// Loading,
	},
};
</script>

<style scoped>
div.file-listing {
	background-color: rgba(216, 216, 216, 0.493);
	border-radius: 3px;
}
img
{
	height: 100px !important;
	width: 100px !important;
}

span.remove-file {
	color: red;
	cursor: pointer;
	float: left;
}

input[type="file"] {
	opacity: 0;

	top: -1px;

	position: fixed;
	cursor: pointer;
}
.popover_btn {
	background-color: rgb(189, 192, 189);
	border-radius: 50%;
	border: none;
	color: #000000;
	padding: 10px;
	text-align: center;
	text-decoration: none;
	display: inline-block;
	font-size: 12px;
	margin: 4px 6px;
}
[data-popover="foo"] {
	background: #444;
	color: #f9f9f9;

	font-size: 12px;
}
</style>
